import type { ConfigProviderThemeVars } from 'vant/es/config-provider/types'

export const themeColor = {
  aura: {
    primary: '#1989fa',
    primary2: '#00ccff',
    secondary: '#BDDFF2',
    background: '#b2e2f9',
    success: '#57AD5A',
    warning: '#FFEB56',
    error: '#FF5252',
    default: '#F8F8F8',
    dark: '#47474A',
    title: '#000000',
    subtitle: '#233956',
  },
  xpress: {
    primary: '#F23790',
    primary2: '#FFA0C0',
    secondary: '#f0c3c9',
    background: '#f0c3c9',
    success: '#57AD5A',
    warning: '#FFEB56',
    error: '#FF5252',
    default: '#F8F8F8',
    dark: '#47474A',
    title: '#000000',
    subtitle: '#233956',
  },
}

export const vantTheme: {
  aura: ConfigProviderThemeVars
  xpress: ConfigProviderThemeVars
} = {
  aura: {
    buttonPrimaryBackground: themeColor.aura.primary,
    buttonPrimaryBorderColor: themeColor.aura.primary,
  },
  xpress: {
    buttonPrimaryBackground: themeColor.xpress.primary,
    buttonPrimaryBorderColor: themeColor.xpress.primary,
  },
}

export const fontFamily = {
  sans: ['Kanit', 'Prompt', 'sans-serif'],
}

export const displayThresholds = {
  thresholds: {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
  },
}

export const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}` : '0 0 0'
}
